import Page from './administrators.page'

let routes = [
  {
    path: '/administrators',
    name: 'Administrators',
    component: Page
  }
]

export default routes
